import { render, staticRenderFns } from "./StopPromotion.vue?vue&type=template&id=5a9114ae"
import script from "./StopPromotion.vue?vue&type=script&lang=js"
export * from "./StopPromotion.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports